import dayjs from 'dayjs';
import { createSelector } from 'reselect';
import { getEvents } from '@src/containers/Filters/selectors/getEvents';
import { getSFUValues } from '@src/containers/Filters/selectors/getSFUValues';
import { getCity } from '@src/containers/Session/selectors/getCity';
import getRouterCtx from '@src/containers/Session/selectors/getRouterCtx';
import { getCapacityItems } from '@src/containers/Filters/selectors/getCapacity';

export const getListingDefaultTitle = createSelector(
	getCity,
	getSFUValues,
	getEvents,
	getRouterCtx,
	getCapacityItems,
	(city, sfu, events, ctx, capacityItems) => {
		let citySlug = '';
		let qttySlug = '';
		let dateSlug = '';

		const { spec: specId, capacity, date } = ctx?.query || {};
		const eventId = specId || sfu.spec;
		const targetEvent = eventId
			? events.find((e) => e.value === `${eventId}`)
			: null;

		if (targetEvent) {
			citySlug = `${targetEvent.label} ${t('в')} ${city.name3}`;
		} else {
			citySlug = city.name;
		}

		const capacitySFU = capacity || sfu.capacity;
		if (capacitySFU) {
			const targetCapacity = capacityItems.find(
				(i) => i.value === capacitySFU,
			);
			if (targetCapacity) {
				qttySlug = `${targetCapacity.label} ${t('гостей')}`;
			}
		}

		if (date) {
			dateSlug = dayjs(date).format('DD.MM.YYYY');
		}

		return `${citySlug ? `${citySlug}` : ''}${
			qttySlug ? ` · ${qttySlug}` : ''
		}${dateSlug ? ` · ${dateSlug}` : ''}`;
	},
);
